import { API_URL } from "../config/config";
import { getRequest } from "../utils/axiosUtils";

export const fetchAccreditationList = async (setAccreditationList, setLoadingAccreditations) => {
  if (setLoadingAccreditations) setLoadingAccreditations(true)
  try {
    const response = await getRequest({
      url: `${API_URL}/accreditation`,
    });
    const accreditations = response?.data?.data;
    if (!response?.data?.success || !Array.isArray(accreditations)) {
      const error = new Error(response?.data?.message || "Accreditations not found");
      error.fieldErrors = response?.data?.errors || {};
      throw error;
    }
    const mappedAccreditations = accreditations.map(item => ({
      label: item.title || item.name,   // support both keys
      value: item._id,
      image: item.image || "",
    }));
    if (setAccreditationList) setAccreditationList(mappedAccreditations)
  } catch (err) {
    if (setAccreditationList) setAccreditationList([])
    const responseData = err?.response?.data;
    if (responseData) {
      const customError = new Error(responseData.message || "Failed to fetch accreditations");
      customError.fieldErrors = responseData.errors || {};
      throw customError;
    }
    throw new Error(err.message || "Unknown error occurred while fetching accreditations");
  } finally {
    if (setLoadingAccreditations) setLoadingAccreditations(false)
  }
}
